import request from '@/utils/request'


// 查询退货订单列表
export function listRefund(query) {
  return request({
    url: '/order/refund/list',
    method: 'get',
    params: query
  })
}

// 查询退货订单分页
export function pageRefund(query) {
  return request({
    url: '/order/refund/page',
    method: 'get',
    params: query
  })
}

// 查询退货订单详细
export function getRefund(data) {
  return request({
    url: '/order/refund/detail',
    method: 'get',
    params: data
  })
}

export function refundReceipt(data) {
  return request({
    url: '/order/refund/receipt',
    method: 'post',
    data: data
  })
}


// 新增退货订单
export function refundApply(data) {
  return request({
    url: '/order/refund/refund/apply',
    method: 'post',
    data: data
  })
}

export function refundPreview(data) {
  return request({
    url: '/order/refund/preview/part',
    method: 'post',
    data: data
  })
}

export function refundPart(data) {
  return request({
    url: '/order/refund/refund/part',
    method: 'post',
    data: data
  })
}

export function refundAmount(data) {
  return request({
    url: '/order/refund/refund/amount',
    method: 'post',
    data: data
  })
}

// 新增退货订单
export function auditRefund(data) {
  return request({
    url: '/order/refund/audit',
    method: 'post',
    data: data
  })
}

export function auditRefundBatch(data) {
  return request({
    url: '/order/refund/audit/batch',
    method: 'post',
    data: data
  })
}

// 修改退货订单
export function updateRefund(data) {
  return request({
    url: '/order/refund/edit',
    method: 'post',
    data: data
  })
}

// 删除退货订单
export function delRefund(data) {
  return request({
    url: '/order/refund/delete',
    method: 'post',
    data: data
  })
}
